// Function to show the expandable box overlay
export function showSearchBoxesOverlay() {
    // console.log("showSearchBoxesOverlay called");
    const expandableBox = document.querySelector(".expandable-box");
    if (expandableBox && !expandableBox.classList.contains("show")) {
        expandableBox.classList.add("expandable-box-overlay");
    } else {
        console.log('IGNORED showSearchBoxesOverlay.');
    }
}

// Function to hide the expandable box overlay
export function hideSearchBoxesOverlay() {
    // console.log("hideSearchBoxesOverlay called");
    const expandableBox = document.querySelector(".expandable-box");
    if (expandableBox) {
        expandableBox.classList.remove("expandable-box-overlay");
    } else {
        console.log('IGNORED hideSearchBoxesOverlay.');
    }
}


// Event listener for Turbo before-cache to show the overlay before page navigation
document.addEventListener('turbo:before-cache', function() {
    console.log("festi turbo:before-cache.");
    showSearchBoxesOverlay();
});

// Event listener for Turbo load to ensure the overlay is hidden when the page is fully loaded
document.addEventListener('turbo:load', function() {
    console.log("festi turbo:load.");
    hideSearchBoxesOverlay();
});

// Event listener for DOMContentLoaded to ensure the overlay is shown when the page is initially loaded
document.addEventListener('DOMContentLoaded', function() {
    console.log('Endpoint URL:', window.location.pathname);
    console.log("festi DOMContentLoaded.");
    showSearchBoxesOverlay();
});